import { useQuery } from '@tanstack/react-query';

import { PluginOlasioVerificationForm } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runOlasioVerificationForm } from '../../requests/runOlasioVerificationForm';

export const useRunOlasioVerificationForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<PluginOlasioVerificationForm> | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'olasio-verification-form', applicationUuid],
    queryFn: () =>
      runOlasioVerificationForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
